// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__ZLX0v","content":"LayoutSettings_content__2w1Za"};